// SKYCORE MAP.NAV.1 — moteur de rotation cartographique INTERNE (sans dépendance, sans modification
// globale des prototypes Leaflet). Principe : le conteneur Leaflet est surdimensionné (diagonale du
// cadre visible) et tourné de -bearing autour de son centre ; la carte reste géographiquement intacte
// (Leaflet travaille dans son repère non tourné). Les conversions pointeur -> point conteneur et les
// déplacements de drag sont inversés par la même rotation. Fonctions PURES ci-dessous.

// Rotation d'un vecteur écran (y vers le bas), sens horaire positif (convention CSS rotate()).
export function rotateVec(x, y, deg) {
  const a = (deg * Math.PI) / 180, c = Math.cos(a), s = Math.sin(a);
  return [x * c - y * s, x * s + y * c];
}

// Cadre Leaflet : taille visible W×H, ou carré de la diagonale lorsque la rotation est active.
export function frameSize(w, h, rotating) {
  if (!rotating) return { w, h, left: 0, top: 0 };
  const d = Math.ceil(Math.hypot(w, h)) + 2;
  return { w: d, h: d, left: Math.round((w - d) / 2), top: Math.round((h - d) / 2) };
}

// Point écran (clientX/Y) -> point du conteneur Leaflet non tourné. `rect` = cadre VISIBLE (non tourné),
// `size` = taille du conteneur Leaflet. Le conteneur est tourné de -bearing : inverse = +bearing.
export function screenToContainerPoint(clientX, clientY, rect, size, bearing) {
  const vx = clientX - (rect.left + rect.width / 2), vy = clientY - (rect.top + rect.height / 2);
  const [ux, uy] = rotateVec(vx, vy, bearing);
  return [size.x / 2 + ux, size.y / 2 + uy];
}

// Inverse (tests / overlays) : point conteneur -> point écran.
export function containerToScreenPoint(px, py, rect, size, bearing) {
  const [vx, vy] = rotateVec(px - size.x / 2, py - size.y / 2, -bearing);
  return [rect.left + rect.width / 2 + vx, rect.top + rect.height / 2 + vy];
}

// Déplacement écran d'un drag -> déplacement dans le repère carte (même rotation inverse).
export const dragOffsetToMap = (dx, dy, bearing) => rotateVec(dx, dy, bearing);

// Orientation VISUELLE finale du symbole drone = cap géographique − rotation de la carte.
// SUIVRE + cap fiable : bearing = cap -> symbole vers le haut. Aucune contre-rotation du symbole.
export const screenHeading = (headingDeg, bearing) => headingDeg - bearing;
